<template>
  <i class="fas" :class="iconClass" :title="titleText"></i>
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    attribute: {
      required: true,
      type: Object
    }
  },
  computed: {
    titleText() {
      return this.value.verified
        ? `Verifiziert: ${this.value.email_verified_at}\nDOI nach ${this.value.verify_duration}`
        : "Noch nicht Verifiziert";
    },
    iconClass() {
      return this.value.verified
        ? ["fa-check", "default-true-html"]
        : ["fa-times", "default-null-html"];
    }
  }
};
</script>

<style></style>
